import React from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppWidget from "./components/WhatsAppWidget";
import styles from "./styles/App.module.css";
import AdminLayout from "./layout/AdminHeaderLayout";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminUserForm from "./pages/Admin/AdminUserForm";
import AdminUserView from "./pages/Admin/AdminUserView";
import Login from "./pages/Admin/Login";
import OrderForm from "./pages/Admin/OrderForm";
import OrderList from "./pages/Admin/OrderList";
import ReviewList from "./pages/Admin/ReviewList";
import AdminUserList from "./pages/Admin/UserList";
import CreateReview from "./pages/CreateReview";
import TrackOrder from "./pages/ClientOrder";
import ProtectedRoute from "./components/protectedRoute";

// Public site layout (with Navbar + Footer)
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <>
    <Navbar />
    {children}
    <Footer />
  </>
);

const AppRoutes: React.FC = () => {
  const location = useLocation();

  // Hide WhatsApp widget on admin pages
  const showWhatsApp = !location.pathname.startsWith("/admin") && location.pathname !== "/login";

  return (
    <>
      <Routes>
        {/* Public pages */}
        <Route path="/" element={<Layout><Home /></Layout>} />
        <Route path="/about" element={<Layout><About /></Layout>} />
        <Route path="/services" element={<Layout><Services /></Layout>} />
        <Route path="/contact" element={<Layout><Contact /></Layout>} />
        <Route path="/reviews/new" element={<Layout><CreateReview /></Layout>} />

        {/* Client protected page */}
        <Route
          path="/track-order"
          element={
            <ProtectedRoute>
              <Layout><TrackOrder /></Layout>
            </ProtectedRoute>
          }
        />

        {/* Admin login — no header/footer */}
        <Route path="/login" element={<Login />} />

        {/* Admin routes — protected */}
        <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="/admin/home" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<AdminUserList />} />
          <Route path="/admin/users/new" element={<AdminUserForm />} />
          <Route path="/admin/users/edit/:id" element={<AdminUserForm />} />
          <Route path="/admin/users/view/:id" element={<AdminUserView />} />
          <Route path="/admin/orders" element={<OrderList />} />
          <Route path="/admin/orders/new" element={<OrderForm />} />
          <Route path="/admin/orders/edit/:id" element={<OrderForm />} />
          <Route path="/admin/reviews" element={<ReviewList />} />
        </Route>
      </Routes>

      {showWhatsApp && <WhatsAppWidget />}
    </>
  );
};

const App: React.FC = () => (
  <Router>
    <ScrollToTop />
    <div className={styles.app}>
      <AppRoutes />
    </div>
  </Router>
);

export default App;
